/* NEXRA 05/10 lan 4 - khoi "Complete the set" dang dong + nhan gia tren nut mua. Markup: snippets/nx-cs.liquid.

   1. NUT MUA trang san pham (khoi co data-nx-v2): chi them mon dang xem, luong mua cua Dawn / nx-pdp.js giu nguyen.
      File nay chi noi GIA dang ban vao nhan: "Add to cart · $28.00". Chua chon size ("Select a size", class
      nx-atc-locked) hoac nut dang bi Dawn khoa (Sold out / Unavailable) thi KHONG dung vao.
      11/10: co o so luong ben trai nut (assets/nx-qty.js) -> tu 2 cai nhan chi con "Add to cart" (bo phan gia).
   2. KHOI Complete the set (trang san pham va ngan keo gio):
        bam "+ Add <loai>"  -> mo hang size ngay trong dong (khong chon san size nao)
        bam mot size        -> POST /cart/add.js mon do, thuoc tinh an _nx_up = pdp | drawer
        trang san pham      -> dong hien "Added · S" + Undo, so tren icon gio doi, KHONG mo ngan keo
        ngan keo            -> ngan keo ve lai sang trang thai 2 mon
        Undo                -> giam dung dong vua them di 1 (so luong 1 thi dong do bi go khoi gio)
        loi                 -> chu ngay duoi dong (mat mang / server tu choi)

   3. DONG UU DAI duoi tieu de khoi (06/10, chi trang san pham): doi theo SO MON TRONG GIO.
        0 mon  "Sold separately · Buy both: <uu dai>"        1 mon  "Add 1 more item: <uu dai>"   (06/10 lan 2: bo "Sold separately")
        2 mon  "✓ <uu dai> unlocked"                          <uu dai> = cum do nx-km quan ly (15% off + free shipping / free shipping)
        tu 3   "✓ <uu dai 3 mon> unlocked"                    08/10: tu 3 mon cum doi sang muc 3 mon (20% off + free shipping)
      So mon doc tu ICON GIO (#cart-icon-bubble): moi duong lam doi gio (nut mua, dong goi y, Undo, sua trong ngan keo,
      Quick View) deu ve lai icon do => theo doi no la du, khong can goi /cart.js.

   🚨 Moi cho ghi DOM deu SO TRUOC KHI GHI: khoi info co cac MutationObserver khac (nx-pdp.js, nx-bis.js, thanh mua
      dinh), ghi de cung gia tri la chung kich nhau vo han (bay 29/09). */
(function () {
  if (window.NXCs) return;

  var MSG_NET = 'Could not add to cart. Check your connection and try again.';
  var MSG_FAIL = 'Could not add to cart. Please try again.';
  var LOCKED = 'nx-atc-locked';
  var SEP = ' · ';
  var busy = false;

  function gon(s) { return (s || '').replace(/\s+/g, ' ').trim(); }
  function emDiu() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function duong(k, macDinh) { return ((window.routes && window.routes[k]) || macDinh) + '.js'; }

  /* ---------- 1. Nhan nut mua: "Add to cart · $28.00" ---------- */
  function v2() { return document.querySelector('[data-nx-v2]'); }

  function nhanNut() {
    var g = v2();
    if (!g) return;
    var b = g.querySelector('.product-form__submit');
    if (!b || b.disabled || b.classList.contains(LOCKED)) return;
    var base = (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
    var sp = b.querySelector('span:not(.visually-hidden)') || b.querySelector('span') || b;
    var cur = gon(sp.textContent);
    // Chi doi khi nhan dang la "Add to cart" tran hoac ban co gia do chinh file nay ghi.
    if (cur !== base && cur.indexOf(base + SEP) !== 0) return;
    var pf = g.querySelector('product-form');
    var sid = pf ? pf.getAttribute('data-section-id') : '';
    var box = sid ? document.getElementById('price-' + sid) : null;
    // price__regular luon mang gia DANG BAN (ke ca khi co gia gach: gia gach nam o price__sale).
    var el = box ? box.querySelector('.price__regular span.price-item') : null;
    var gia = el ? gon(el.textContent) : '';
    // NEXRA 11/10 (o so luong, assets/nx-qty.js): tu 2 cai thi nhan chi ghi "Add to cart", BO phan gia (anh chot 11/10:
    // khong ghi gia 1 cai canh so luong 2, cung khong ghi tong chua tru uu dai mua nhieu). So luong 1: nhu truoc.
    if (soLuong(g) > 1) gia = '';
    var want = gia ? base + SEP + gia : base;
    if (cur === want) return;
    // Phan gia nam trong span rieng: hang nut hep (co o so luong ben trai) thi CSS an phan nay, nhan khong xuong dong.
    sp.textContent = base;
    if (gia) {
      var sg = document.createElement('span');
      sg.className = 'nx-atc__gia';
      sg.textContent = SEP + gia;
      sp.appendChild(sg);
    }
  }

  function soLuong(g) {
    var i = g.querySelector('[data-nx-qty-in]');
    var n = i ? parseInt(String(i.value || '').replace(/[^0-9]/g, ''), 10) : 1;
    return n > 0 ? n : 1;
  }

  function theoDoiNut() {
    var g = v2();
    if (!g) return;
    var host = (g.closest && g.closest('.product__info-container')) || document.body;
    var cho = false;
    // setTimeout chu khong requestAnimationFrame: cua so bi che thi rAF dung (bay 05/10), nhan se khong bao gio doi.
    new MutationObserver(function () {
      if (cho) return;
      cho = true;
      setTimeout(function () { cho = false; nhanNut(); }, 0);
    }).observe(host, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class'] });
    nhanNut();
  }

  /* ---------- 2. Khoi Complete the set ---------- */
  function doc(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  // Ve lai icon gio + noi dung ngan keo tu section server tra ve. KHONG mo ngan keo.
  // Thay ruot .drawer__inner (nhu cart.js cua Dawn luc doi so luong): ngan keo dang mo van mo, lop phu giu nguyen.
  function veGio(sec, dangMo) {
    if (!sec) return;
    var bub = document.getElementById('cart-icon-bubble');
    if (bub && sec['cart-icon-bubble']) {
      var sb = doc(sec['cart-icon-bubble']).querySelector('.shopify-section');
      if (sb) bub.innerHTML = sb.innerHTML;
    }
    var gio = document.querySelector('cart-drawer');
    var cu = gio ? gio.querySelector('.drawer__inner') : null;
    if (!gio || !cu || !sec['cart-drawer']) return;
    var d = doc(sec['cart-drawer']);
    var moi = d.querySelector('.drawer__inner');
    var host = d.querySelector('cart-drawer');
    if (!moi) return;
    cu.innerHTML = moi.innerHTML;
    var trong = !!(host && host.classList.contains('is-empty'));
    if (gio.classList.contains('is-empty') !== trong) gio.classList.toggle('is-empty', trong);
    if (cu.classList.contains('is-empty')) cu.classList.remove('is-empty');
    if (dangMo && typeof trapFocus === 'function') {
      try { trapFocus(document.getElementById('CartDrawer') || gio, cu); } catch (e) {}
    }
  }

  function loiEl(row) { return row ? row.querySelector('[data-nx-cs-err]') : null; }
  function xoaLoi(row) {
    var e = loiEl(row);
    if (e && !e.hidden) e.hidden = true;
  }
  function baoLoi(row, msg) {
    var e = loiEl(row);
    if (!e) return;
    var t = e.querySelector('[data-nx-cs-err-text]') || e;
    t.textContent = msg;
    e.hidden = false;
    if (e.scrollIntoView) e.scrollIntoView({ block: 'nearest', behavior: emDiu() ? 'auto' : 'smooth' });
  }
  // Doc cho trinh doc man hinh (vung role=status cua khoi).
  function noi(row, msg) {
    var g = row && row.closest ? row.closest('[data-nx-cs]') : null;
    var l = g ? g.querySelector('[data-nx-cs-live]') : null;
    if (l) l.textContent = msg;
  }
  function ten(row) { return (row && row.getAttribute('data-name')) || 'Item'; }

  // Mo / dong hang size cua mot dong. kb = kich hoat bang ban phim (hoac trinh doc man hinh) -> moi doi focus.
  function moDong(row, mo, kb) {
    var add = row.querySelector('[data-nx-cs-add]');
    var pick = row.querySelector('[data-nx-cs-pick]');
    if (!add || !pick) return;
    if (row.classList.contains('is-open') !== mo) row.classList.toggle('is-open', mo);
    if (pick.hidden === mo) pick.hidden = !mo;
    add.setAttribute('aria-expanded', mo ? 'true' : 'false');
    if (mo) {
      xoaLoi(row);
      // Nut "+ Add" nhuong cho khi mo: ban phim thi dua focus vao nhom size (khong vao o size nao - khong chon ho khach).
      if (kb && pick.focus) pick.focus({ preventScroll: true });
      if (pick.scrollIntoView) pick.scrollIntoView({ block: 'nearest', behavior: emDiu() ? 'auto' : 'smooth' });
    } else if (kb && add.focus) {
      add.focus({ preventScroll: true });
    }
  }

  function daThem(row, key, size, kb, vid) {
    var pick = row.querySelector('[data-nx-cs-pick]');
    var done = row.querySelector('[data-nx-cs-done]');
    var add = row.querySelector('[data-nx-cs-add]');
    row.setAttribute('data-nx-cs-key', key || '');
    row.setAttribute('data-nx-cs-vid', vid || '');
    row.classList.remove('is-open');
    row.classList.add('is-done');
    if (pick) pick.hidden = true;
    if (add) add.setAttribute('aria-expanded', 'false');
    if (done) {
      var s = done.querySelector('[data-nx-cs-done-size]');
      if (s) s.textContent = size;
      done.hidden = false;
      if (kb && done.focus) done.focus({ preventScroll: true });
    }
    noi(row, ten(row) + ', size ' + size + ', added to your cart.');
  }

  function datLai(row, kb) {
    var done = row.querySelector('[data-nx-cs-done]');
    var add = row.querySelector('[data-nx-cs-add]');
    row.removeAttribute('data-nx-cs-key');
    row.removeAttribute('data-nx-cs-vid');
    row.classList.remove('is-done');
    if (done) done.hidden = true;
    if (kb && add && add.focus) add.focus({ preventScroll: true });
  }

  function guiJson(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (x) { return x.json(); });
  }

  function baoTrangGio(res) {
    // Trang /cart (co the cart-items): bao cho Dawn ve lai danh sach chinh.
    if (!document.querySelector('cart-items')) return;
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nx-cs', cartData: res }); } catch (e) {}
    }
  }

  function them(row, sz, kb) {
    if (busy || !row || !sz) return;
    var goc = row.closest('[data-nx-cs]');
    var ctx = (goc && goc.getAttribute('data-ctx')) === 'drawer' ? 'drawer' : 'pdp';
    var id = sz.getAttribute('data-id');
    var size = sz.getAttribute('data-size') || '';
    if (!id) {
      baoLoi(row, (window.variantStrings && window.variantStrings.unavailable) || MSG_FAIL);
      return;
    }
    // NEXRA 09/10 (tam ngung ban): bien the nam trong settings.nx_chan_ids (window.NX_CHAN) thi khong gui them gio.
    if (window.NX_CHAN && window.NX_CHAN.indexOf(String(id)) > -1) {
      baoLoi(row, (window.variantStrings && window.variantStrings.soldOut) || 'Sold out');
      return;
    }
    busy = true;
    xoaLoi(row);
    row.classList.add('is-busy');
    sz.classList.add('is-loading');
    sz.setAttribute('aria-busy', 'true');
    var tenMon = ten(row);
    var netErr = false;
    guiJson(duong('cart_add_url', '/cart/add'), {
      items: [{ id: Number(id), quantity: 1, properties: { _nx_up: ctx } }],
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname
    })
      // Chi loi cua fetch / doc JSON moi tinh la "khong them duoc"; loi nem ra luc ve lai gio thi khong bao nham.
      .catch(function (e) { netErr = true; throw e; })
      .then(function (res) {
        if (res && res.status) {
          baoLoi(row, (typeof res.description === 'string' && res.description) ||
                      (typeof res.message === 'string' && res.message) || MSG_FAIL);
          return;
        }
        var it = res && res.items && res.items[0];
        if (ctx === 'drawer') {
          veGio(res && res.sections, true);
          var live = document.getElementById('CartDrawer-LiveRegionText');
          if (live) live.textContent = tenMon + ', size ' + size + ', added to your cart.';
        } else {
          veGio(res && res.sections, false);
          daThem(row, it ? it.key : '', size, kb, id);
        }
        baoTrangGio(res);
      })
      .catch(function (e) {
        if (netErr) baoLoi(row, MSG_NET);
        else if (window.console) console.error(e);
      })
      .finally(function () {
        busy = false;
        row.classList.remove('is-busy');
        sz.classList.remove('is-loading');
        sz.removeAttribute('aria-busy');
      });
  }

  // Undo: giam dung dong vua them di 1 (so luong 1 = go dong). Dong da bi go o cho khac thi chi tra dong ve nhu cu.
  function hoan(row, kb) {
    if (busy || !row) return;
    var key = row.getAttribute('data-nx-cs-key') || '';
    var vid = row.getAttribute('data-nx-cs-vid') || '';
    var tenMon = ten(row);
    busy = true;
    xoaLoi(row);
    row.classList.add('is-busy');
    var netErr = false;
    function mang(e) { netErr = true; throw e; }
    var viec = (!key && !vid) ? Promise.resolve(null) : fetch(duong('cart_url', '/cart'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (x) { return x.json(); })
      .catch(mang)
      .then(function (cart) {
        // Key cua dong gio DOI moi khi gio thay doi (them mon khac, discount ap vao) -> khong thay key cu thi tim
        // dung dong do theo bien the + thuoc tinh _nx_up = pdp (chi khoi nay tren trang san pham gan gia tri do).
        var it = null;
        var ds = (cart && cart.items) || [];
        ds.forEach(function (x) { if (!it && key && x.key === key) it = x; });
        if (!it && vid) {
          ds.forEach(function (x) {
            if (!it && String(x.variant_id) === String(vid) && x.properties && x.properties._nx_up === 'pdp') it = x;
          });
        }
        if (!it) return null;
        return guiJson(duong('cart_change_url', '/cart/change'), {
          id: it.key,
          quantity: Math.max(0, (parseInt(it.quantity, 10) || 1) - 1),
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        }).catch(mang);
      });
    viec
      .then(function (res) {
        if (res && res.status) {
          baoLoi(row, (typeof res.description === 'string' && res.description) ||
                      (typeof res.message === 'string' && res.message) ||
                      (window.cartStrings && window.cartStrings.error) || MSG_NET);
          return;
        }
        if (res && res.sections) veGio(res.sections, false);
        datLai(row, kb);
        noi(row, tenMon + ' removed from your cart.');
        if (res) baoTrangGio(res);
      })
      .catch(function (e) {
        if (netErr) baoLoi(row, (window.cartStrings && window.cartStrings.error) || MSG_NET);
        else if (window.console) console.error(e);
      })
      .finally(function () {
        busy = false;
        row.classList.remove('is-busy');
      });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var kb = e.detail === 0;
    var add = t.closest('[data-nx-cs-add]');
    if (add) {
      e.preventDefault();
      var row = add.closest('[data-nx-cs-row]');
      if (!row || busy) return;
      var goc = row.closest('[data-nx-cs]');
      // Moi luc chi mot dong mo hang size.
      if (goc) {
        goc.querySelectorAll('[data-nx-cs-row].is-open').forEach(function (r) { if (r !== row) moDong(r, false, false); });
      }
      moDong(row, !row.classList.contains('is-open'), kb);
      return;
    }
    var sz = t.closest('[data-nx-cs-size]');
    if (sz) {
      e.preventDefault();
      if (sz.getAttribute('aria-disabled') === 'true') return;
      them(sz.closest('[data-nx-cs-row]'), sz, kb);
      return;
    }
    var un = t.closest('[data-nx-cs-undo]');
    if (un) {
      e.preventDefault();
      hoan(un.closest('[data-nx-cs-row]'), kb);
    }
  });

  // Esc khi dang mo hang size tren trang san pham: dong lai, focus ve nut "+ Add".
  // Trong ngan keo thi de Dawn dong ca ngan keo nhu moi khi.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var t = e.target;
    var row = t && t.closest ? t.closest('[data-nx-cs-row].is-open') : null;
    if (!row || row.closest('cart-drawer')) return;
    moDong(row, false, true);
  });

  // Dawn doi bien the bang AJAX (hang mau cua trang goc Vision) va khong render lai khoi nay: lay ban server da render
  // voi mau moi tu chinh HTML Dawn vua tai (su kien variantChange) roi thay vao. Chi thay khi chu ky doi.
  function ganPubSub() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
      try {
        var d = ev && ev.data;
        if (d && d.html && d.sectionId) {
          var id = 'nx-cs-' + d.sectionId;
          var cu = document.getElementById(id);
          var moi = d.html.getElementById ? d.html.getElementById(id) : null;
          if (cu && moi && cu.getAttribute('data-sig') !== moi.getAttribute('data-sig')) {
            cu.innerHTML = moi.innerHTML;
            cu.setAttribute('data-sig', moi.getAttribute('data-sig') || '');
            cu.setAttribute('data-n', moi.getAttribute('data-n') || '');
            // lop nx-cs--dai / nx-cs--ngan (nhan nut rut theo ca khoi) nam o goc khoi: chep theo ban moi
            if (cu.className !== moi.className) cu.className = moi.className;
            if (window.NX_KM) window.NX_KM();
            uuDai();
          }
        }
      } catch (e) {}
      setTimeout(nhanNut, 0);
    });
  }

  /* ---------- 3. Dong uu dai duoi tieu de: doi theo so mon trong gio ---------- */
  // 08/10 (uu dai 15 / 20): 4 trang thai. 0 / 1 / 2 mon noi muc 2 mon (data-nx-cs-of2), tu 3 mon noi muc 3 mon (data-nx-cs-of3).
  var UD_LEAD = ['Buy both: ', 'Add 1 more item: ', '✓ ', '✓ '];
  var UD_TAIL = ['', '', ' unlocked', ' unlocked'];

  // So mon trong gio doc tu icon gio. null = trang khong co icon (giu trang thai server da in).
  function soMon() {
    var b = document.getElementById('cart-icon-bubble');
    if (!b) return null;
    var c = b.querySelector('.cart-count-bubble');
    if (!c) return 0;
    var s = c.querySelector('span[aria-hidden="true"]');
    var n = s ? parseInt(s.textContent, 10) : NaN;
    // Tu 100 mon Dawn khong in so: van la "tu 3 mon".
    return isNaN(n) ? 3 : n;
  }

  function uuDai() {
    var ps = document.querySelectorAll('[data-nx-cs-sub]');
    if (!ps.length) return;
    var n = soMon();
    for (var i = 0; i < ps.length; i++) {
      var p = ps[i];
      var k = n;
      if (k === null) k = parseInt(p.getAttribute('data-nx-cs-tt'), 10) || 0;
      k = k >= 3 ? 3 : (k === 2 ? 2 : (k === 1 ? 1 : 0));
      var a = p.querySelector('[data-nx-cs-sub-a]');
      var lead = p.querySelector('[data-nx-cs-sub-lead]');
      var tail = p.querySelector('[data-nx-cs-sub-tail]');
      var km = p.querySelector('.nx-cs__sub-in [data-nx-km-live]');
      if (p.getAttribute('data-nx-cs-tt') !== String(k)) p.setAttribute('data-nx-cs-tt', String(k));
      // 06/10 lan 2: "Sold separately" chi con o trang thai 0 mon (1 mon: "Add 1 more item: ..." cho vua 1 hang).
      if (a && a.hidden !== (k !== 0)) a.hidden = (k !== 0);
      if (lead && lead.textContent !== UD_LEAD[k]) lead.textContent = UD_LEAD[k];
      if (tail && tail.textContent !== UD_TAIL[k]) tail.textContent = UD_TAIL[k];
      // Khoi giu cho (CSS) can biet cum uu dai dang o ban nao: "sale" = chi free shipping (pha sale hoac KM10 tat).
      if (km) {
        // 08/10: cum uu dai theo so mon. Doi data-nx-km-done roi de nx-km ve lai (chi khi cum can dung KHAC cum dang co).
        var muon = km.getAttribute(k === 3 ? 'data-nx-cs-of3' : 'data-nx-cs-of2');
        if (muon && km.getAttribute('data-nx-km-done') !== muon) {
          km.setAttribute('data-nx-km-done', muon);
          km.removeAttribute('data-nx-km-pha');
          if (window.NX_KM) window.NX_KM();
        }
        var ban = km.textContent === km.getAttribute('data-nx-km-done') ? 'done' : 'sale';
        if (p.getAttribute('data-nx-cs-km') !== ban) p.setAttribute('data-nx-cs-km', ban);
      }
    }
  }

  function theoDoiGio() {
    var cho = false;
    function hen() {
      if (cho) return;
      cho = true;
      setTimeout(function () { cho = false; uuDai(); }, 0);
    }
    var b = document.getElementById('cart-icon-bubble');
    if (b) new MutationObserver(hen).observe(b, { childList: true, subtree: true, characterData: true });
    // Pha sale doi khi trang dang mo (class tren html): nx-km doi cum uu dai truoc, minh cap nhat khoi giu cho sau.
    new MutationObserver(hen).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    uuDai();
  }

  function boot() {
    theoDoiNut();
    ganPubSub();
    theoDoiGio();
  }

  // 11/10: veGio dung chung cho assets/nx-qty.js (ve lai icon gio + ngan keo sau khi nut mua bao loi).
  window.NXCs = { sync: nhanNut, offer: uuDai, veGio: veGio };
  window.addEventListener('pageshow', nhanNut);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
